import { useQuery } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { useApi } from "../../../hooks/useApi"

/**
 * Hook to fetch a single instrument's full details.
 */
const useTradingInstrument = ({ instrumentId }: { instrumentId: number | undefined }) => {
  const { scientApi } = useApi()

  const { data, error, isLoading } = useQuery(
    ["trading_instrument", instrumentId],
    () => scientApi.trading.getTradingInstrument(instrumentId!),
    {
      retry: 1,
      enabled: instrumentId !== undefined,
    },
  )

  return {
    instrument: data,
    error: error as AxiosError,
    isLoading,
  }
}

export default useTradingInstrument
